<template>
    <div class="continer">
        <img class="bg" src="@/assets/images/busImage/login_background.png"/>
        <div class="login-box">
            <div class="title">财务智能自助系统</div>
            <img class="login-way" @click="changeLoginWay" :src="currentLoginWay.icon">
            <div v-if="currentLoginWay.value === 'accountLogin'">
                <div class="tab-box">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane v-for="(tab) in loginWay" :key="tab.id" :label="tab.name" :name="tab.id"></el-tab-pane>
                    </el-tabs>
                </div>
                <el-form class="login-form" :model="loginForm" :rules="rules" ref="loginForm">
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.username" placeholder="请输入账户名">
                            <img class="input-icon" slot="prefix" src="@/assets/images/busImage/user.png">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="loginForm.password" placeholder="请输入密码" type="password">
                            <img class="input-icon" slot="prefix" src="@/assets/images/busImage/unlock.png">
                        </el-input>
                    </el-form-item>
                    <div class="code-box" v-if="currentActiveTab.enableCode">
                        <el-form-item class="code-box-item" key="code"  prop="code">
                            <el-input v-model="loginForm.code" placeholder="请输入验证码">
                                <img class="input-icon" slot="prefix" src="@/assets/images/busImage/key.png">
                            </el-input>
                        </el-form-item>
                        <img class="code-image" @click="getCodeInfo" :src="codeInfo.showUrl">
                    </div>
                    <div class="code-box" v-else>
                        <el-form-item class="code-box-item" key="noCode"></el-form-item>
                    </div>
                    <div class="submit-button" @click="handleLogin">登 录</div>
                </el-form>
            </div>
            <div v-else>
                <img class="face-login-content" src="@/assets/images/busImage/peopleHaveBorder.png">
                <div class="face-login" @click="toFaceLogin"><img class="face-login-icon" src="@/assets/images/busImage/face_login.png"/>人脸识别</div>
                <div class="gather-btn">
                    <img src="@/assets/images/busImage/face_gather.png">
                    <div class="gather-text" @click="toFaceGather">人像采集</div>
                </div>
            </div>
            
        </div>
        <errorDialog :dialogVisible="msgDialogVisible" :errorMessage="msgError"></errorDialog>
        <tipsDialog :dialogVisible="tipsDialogVisible" :tipsMessage="tipsMessage"></tipsDialog>
        <!-- 退票流程 -->
        <exitTicketProcess ref="exitTicketProcess" exitTitle="托盘上存在滞留文件，已退出，请取走滞留文件" @dishHaveNoPaper="dishHaveNoPaper" @dishHandleFinish="dishHaveNoPaper"></exitTicketProcess>
    </div>
</template>
<script> 
import { login,getLoginWay,getCode } from '@/api/user'
import errorDialog from '@/components/errorDialog'
import tipsDialog from '@/components/tipsDialog'
import exitTicketProcess from '@/components/exitTicketProcess'
import { debounce } from 'lodash'
export default {
    name: 'login',
    components: { errorDialog,tipsDialog,exitTicketProcess },
    data() {
        return {
            loginForm: {
                username: "",
                password: "",
                code:""
            },
            frontLoginWay: [
                {
                    icon:require('@/assets/images/busImage/faceLogin.png'),
                    name:'账号密码登录',
                    value:"accountLogin"
                },
                {
                    icon:require('@/assets/images/busImage/otherLogin.png'),
                    name:'人脸登录',
                    value:"faceLogin"
                }
            ],
            activeName:'',
            currentActiveName:'',
            currentActiveTab:{}, // 当前选择的登录方式tab
            currentLoginWay:{},
            currentLoginWayIndex:0,
            loginWay: [],
            codeInfo:{},
            rules: {
                username: [
                    { required: true, message: '请输入账户名', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ]
            },
            activeName: 'first',
            //所有组件列表
            moduleList: [],
            //所有组件状态列表
            modulesStatus: [],
            //定时更新组件状态时间 默认30秒
            updateModulesTime: 30000,
            //定时器
            updateTimer: undefined,
            // 错误信息弹窗
            msgDialogVisible: false, 
            msgError: '',
            // 警告信息
            tipsDialogVisible: false,
            tipsMessage:'',
            // 过渡态弹窗
            loadingDialogVisible: false,
            loadingMsg:'',
            // 业务弹框

        }
    },
    mounted(){
        this.checkDeviceStatus()
        this.addDeviceStatusChanged()
        this.$emit('ControlLight', 'eject_light', '0');
        this.$emit('ControlLight', 'printer_light', '0');
        this.getLoginWayInfo()
        // 默认登录方式为账号密码登录
        this.currentLoginWay = this.frontLoginWay[this.currentLoginWayIndex]
    },
    destroyed () {
        this.stopUpdateTimer();
        this.$emit('StopPlay');
    },
    methods: {
        changeLoginWay(){
            this.currentLoginWayIndex = this.currentLoginWayIndex === 0 ? 1: 0;
            this.currentLoginWay = this.frontLoginWay[this.currentLoginWayIndex]
        },
        getLoginWayInfo(){
            getLoginWay().then(res => {
                if(res.code === 200){
                    this.loginWay = res.data || []
                    this.activeName = this.loginWay[0].id
                    this.currentActiveName = this.activeName
                    this.currentActiveTab = this.loginWay[0]
                    this.getCodeInfo()
                    
                }
            })
        },
        getCodeInfo(){
            if(!this.currentActiveTab.enableCode)return
            if(!this.activeName) return 
            getCode({loginWay: this.activeName}).then(res => {
                if(res.code === 200){
                    this.codeInfo = res.data || {}
                    this.codeInfo.showUrl = 'data:image/jpeg;base64,' + res.data.img
                }
            })
        },
        handleClick(){
            if(this.currentActiveName === this.activeName) return
            this.$refs.loginForm.resetFields()
            this.$nextTick(() => {
                this.currentActiveName = this.activeName
                this.currentActiveTab = JSON.parse(JSON.stringify(this.loginWay)).filter(item => item.id === this.activeName)[0]
                this.getCodeInfo()
            })
        },
        submitLogin(){
            if(this.msgDialogVisible) return
            let loginForm = {
                ...this.loginForm,
                loginWay:this.activeName,
                uuid: this.codeInfo.uuid 
            }
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.$store.dispatch('Login',loginForm).then(() => {
                        this.$router.push({name: 'start'})
                    }).catch((e) => {
                        this.getCodeInfo()
                    })
                } else {
                    return false;
                }
            });
        },
        handleLogin: debounce(function(){
            this.submitLogin()
        },1000),
        toFaceLogin: debounce(function(){
            this.$router.push({name: 'faceLogin'})
        },1000),
        toFaceGather(){
            let queryData = {
                loginWay: this.loginWay[0].id,
                name: this.loginWay[0].name
            }
            this.$router.push({name: 'faceGather',query:queryData})
        },
        // 检测硬件状态
        checkDeviceStatus(){
            let errorStatus = this.$route.query.status
            if(errorStatus){
                this.msgDialogVisible = true;
                this.msgError = '纸仓已满，无法继续制单，请联系管理员取票';
            }else {
                this.$refs.exitTicketProcess.getDishHavePaper()
            }
        },
        dishHaveNoPaper(){
            this.updateModuleStatusHadnler();
            this.beginUpdateTimer();
        },
        // -------硬件部分--------
        // 添加组件监听
        addDeviceStatusChanged() {
            this.moduleList.push(this.sys);
            this.moduleList.push(this.siu);
            this.moduleList.push(this.ptr);
            this.moduleList.push(this.ist);
            this.moduleList.push(this.cam);
            for (let i = 0; i < this.moduleList.length; i++) {
                //清除状态监听，重新添加
                this.moduleList[i].removeAllEventListener();
                this.moduleList[i].on("onStatusChanged", this.onStatusChangedComplete);
            }
        },
        // 硬件状态发生变化后回调
        async onStatusChangedComplete(params) {
            console.info("状态变化:" + JSON.stringify(params));
            await this.getStatus(this.moduleList);
            this.updateModuleStatus();
        },
        // 获取硬件状态
        async getStatus(moduleList) {
            this.modulesStatus = [];
			for(let i = 0; i < moduleList.length; i++){				
				let moduleStatus = await moduleList[i].getStatus();
				console.info("moduleStatus============" + JSON.stringify(moduleStatus));	
                let errorMsg = '';
                let module = await moduleList[i];
                if(module.config.device == 'IST') { //收票模块，再执行一次获取传感器状态
                    let result = await this.ist.call("get_sensor_status");
                    console.log('get_sensor_status:' + JSON.stringify(result));
                    if(result.result == 0) {
                        let sensor = result.sensor;
                        let paperDishSensor = sensor.sensor1; //托盘上是否有纸，有纸0；无纸1；
                        let exportPaperUnit = sensor.sensor13; //排纸单元是否卡纸，卡纸0，正常1；
                        let scannerLocationSensor = sensor.sensor17; //扫描仪是否弹出，未弹出 0；弹出 1
                        //检查托盘是否有纸
                        if(paperDishSensor == 0) { //有纸
                            errorMsg += '托盘上存在滞留文件';
                        }
                        //检查托盘是否有纸
                        if(exportPaperUnit == 0) { //有纸
                            errorMsg += '排纸单元卡纸';
                        }
                        //检查托盘是否有纸
                        if(scannerLocationSensor == 1) { //有纸
                            errorMsg += '扫描仪弹出未推回';
                        }
                        if(errorMsg != '') {
                            if(moduleStatus.status == 0) { //获取状态正常，但传感器异常，则修改正常状态值
                                moduleStatus.status = -1;
                                moduleStatus.message = errorMsg;
                            } else { //状态非正常，那么传感器异常直接加在后面即可。
                                if(moduleStatus.message != '') {
                                    moduleStatus.message = moduleStatus.message + ';' + errorMsg;
                                } else {
                                    moduleStatus.status_message = moduleStatus.status_message + ';' + errorMsg;
                                }
                            }
                        }
                    } else {
                        let errorMsg = '获取收票模块传感器发生错误';
                        if(moduleStatus.message != '') {
                            moduleStatus.message = moduleStatus.message + ';' + errorMsg;
                        } else {
                            moduleStatus.status_message = moduleStatus.status_message + ';' + errorMsg;
                        }
                    }
                }
                this.setModuleStatus(moduleList[i],moduleStatus);
			}
        },
        //设置硬件状态信息，信息以status_message为准
        setModuleStatus(g_module, moduleStatus) {
			let module = {
                    "moduleId" : g_module.config.id,
                    "name" : g_module.config.devname,
					"service" : g_module.config.service,
					"status" : moduleStatus.status,
                    "message" : moduleStatus.message != '' ? moduleStatus.message : '',
                    "statusCode" : moduleStatus.status_code != '' ? moduleStatus.status_code : '',
					"deviceMessage" : moduleStatus.status_message != '' ? moduleStatus.status_message : '',
					"remark" : moduleStatus.device_info
			};
            //针对打印机或者其他特殊硬件处理
            let remark = module.remark;
            if((typeof remark !== "undefined") && (typeof remark !== "string")) {//不是字符串的转成字符串
                module.remark = JSON.stringify(remark);
            }
			this.modulesStatus.push(module);
        },
        beginUpdateTimer() {
            let _this = this;
            this.updateTimer = setInterval(() => {
                _this.updateModuleStatusHadnler();
            }, this.updateModulesTime);
        },
        stopUpdateTimer() {
            if(typeof(this.updateTimer) !== "undefined") {
                clearInterval(this.updateTimer);
            }
        },
        async updateModuleStatusHadnler() {
            await this.getStatus(this.moduleList);
            this.updateModuleStatus();
        },
        updateModuleStatus() {
            console.warn("===============更新状态");
            console.log(this.modulesStatus);
            let existError = false
            let existWarning  = false
            let errorMsg = ''
            let tipsMsg = ''
            for (let i = 0; i < this.modulesStatus.length; i++) {
                let status = this.modulesStatus[i].status
                if(this.modulesStatus[i].service === "ptr"){
                    // 单独处理打印机纸盒问题
                    // let result = JSON.parse(this.modulesStatus[i].remark || '{}')
                    // let name = this.modulesStatus[i].name
                    // let carton = result.bin[1] || {}
                    // if(carton.status > 0){
                    //     existWarning = true  
                    //     let message = carton.status_message
                    //     tipsMsg = tipsMsg + name + ':' + message + ';'
                    // }else if(carton.status < 0){
                    //     existError = true;
                    //     let message = carton.status_message
                    //     errorMsg = errorMsg + name + ':' + message + ';'
                    // }  
                }else {
                    if( this.modulesStatus[i].status > 0){
                        existWarning = true
                        let name = this.modulesStatus[i].name
                        let message = ''
                        if(this.modulesStatus[i].message != '') {
                            message = this.modulesStatus[i].message
                        } else {
                            message = this.modulesStatus[i].deviceMessage
                        }
                        tipsMsg = tipsMsg + name + ':' + message + ';'
                    }else if(this.modulesStatus[i].status < 0){
                        existError = true;
                        let name = this.modulesStatus[i].name
                        let message = ''
                        if(this.modulesStatus[i].message != '') {
                        message = this.modulesStatus[i].message
                        } else {
                            message = this.modulesStatus[i].deviceMessage
                        }
                        errorMsg = errorMsg + name + ':' + message + ';'
                    }
                }
            }
            if(existError) {
                this.msgDialogVisible = true;
                this.msgError = errorMsg;
            }else if(existWarning){
                this.tipsDialogVisible = true;
                this.tipsMessage = '警告：' + tipsMsg
                setTimeout(() => {
                    this.tipsDialogVisible = false;
                }, 1000)
            } else {
                this.msgDialogVisible = false;
                this.tipsDialogVisible = false;
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        .bg {
            height: 100%;
            width: 100%;
            min-height: 100vh; /* 确保至少为视口高度 */
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .login-box {
        position: absolute;
        top: 144px;
        right: 105px;
        width: 677px;
        height: 800px;
        box-sizing: border-box;
        padding: 68px 72px 0 72px;
        background: #FFFFFF;
        box-shadow: 0px 0px 1px 0px rgba(255,12,55,0.07), 0px 1px 2px 0px rgba(255,147,1,0.13), 0px 2px 4px 0px rgba(255,12,55,0.07);
        border-radius: 41px;
        .login-way {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        .title {
            text-align: center;
            font-size: 48px;
            color: #B23B34;
            letter-spacing: 2px;
            text-align: center;
            font-weight: 600;
        }
        .tab-box {
            margin-top: 53px;
            /deep/ .el-tabs__active-bar {
                position: absolute;
                top: 48px;
                left: 0;
                height: 2px;
                width: 266px;
                background-color: #B23B34;
                z-index: 1;
                transition: transform .3s cubic-bezier(.645,.045,.355,1);
                list-style: none;
            }
            /deep/ .el-tabs__item{
                width: 266px;
                font-size: 24px;
                font-weight: 600;
                text-align: center;
                color: #c0c0c0;
                padding-bottom: 50px;
            }
            /deep/ .el-tabs__item.is-active {
                    color: #B23B34;
                }
            /deep/ .el-tabs__item:hover {
                    color: #B23B34;
                }
        } 
        .login-form {
            margin-top: 20px;
            /deep/ input {
                width: 527px;
                height: 80px;
                box-sizing: border-box;
                padding-left: 80px;
                border-radius: 6px;
                border: 2px solid #FFD6DC;
                font-size: 26px;
            }
            /deep/ .el-form-item__content{
                width: 527px;
                height: 80px;
            }
            /deep/ .el-input__prefix{
                display: flex;
                align-items: center;
            }
            /deep/ .el-form-item__error{
                font-size: 16px;
            }
            /deep/ .code-box-item  input{
                width: 377px;
                height: 80px;
                box-sizing: border-box;
                padding-left: 80px;
                border-radius: 6px;
                border: 2px solid #FFD6DC;
                font-size: 26px;
            }
            /deep/ .code-box-item .el-form-item__content{
                width: 377px;
                height: 80px;
            }
        }
        .input-icon {
            height: 40px;
            width: 40px;
            margin-left: 13px;
        }
        .code-box {
            display: flex;
        }
        .code-image {
            width: 140px;
            height: 80px;
            margin-left: 10px;
        }
        .submit-button {
            width: 527px;
            height: 80px;
            line-height: 80px;
            margin-top: 30px;
            background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
            box-shadow: 0px 2px 4px 0px rgba(255,12,55,0.07);
            border-radius: 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #FFFFFF;
            text-shadow: 0px 2px 4px rgba(255,12,55,0.07);
        }
        .face-login-content {
            margin: 73px 115px;
            height: 302px;
            width: 302px;
        }
        .face-login {
            width: 527px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #FFE4E9;
            border-radius: 6px;
            font-size: 31px;
            color: #F7636E;
            &-icon {
                width: 28px;
                height: 28px;
                margin-right: 14px;
                margin-top: 5px;
            }
        }
        .gather-btn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 30px;
            .gather-text {
                margin-left: 4px;
                font-size: 25px;
                color: #F7636E;
                line-height: 34px;
                letter-spacing: 1px;
            }
        }
    }
</style>


